import { herausloesen, istHerausloesbar } from './BausteinProvider';

/**
 * „Als Baustein herauslösen" direkt am Element.
 *
 * Der Eintrag steht auch im Schraubenschlüssel-Menü — dort aber unauffindbar:
 * Bei einem eingeklappten Sub-Prozess enthält das Menü sechzehn Einträge, von
 * denen ohne Scrollen nur acht zu sehen sind, und der Eintrag liegt unter den
 * verborgenen. Gemessen, nicht vermutet. Dasselbe gilt für den älteren Eintrag
 * „Sub-process (from file)".
 *
 * Das Kontext-Pad liegt sichtbar neben dem markierten Element — derselbe Weg,
 * den der CollapseToggleContextPadProvider aus demselben Grund geht.
 */
export default function BausteinContextPadProvider(contextPad, injector, translate) {
  contextPad.registerProvider(890, this);
  this._injector = injector;
  this._translate = translate;
}

BausteinContextPadProvider.$inject = ['contextPad', 'injector', 'translate'];

BausteinContextPadProvider.prototype.getContextPadEntries = function (element) {
  if (!istHerausloesbar(element)) return {};

  const injector = this._injector;
  const translate = this._translate;

  return {
    'baustein-extract': {
      group: 'edit',
      // Eigenes Symbol statt bpmn-icon-call-activity: Letzteres ist im Pad
      // kaum vom Sub-Prozess-Symbol daneben zu unterscheiden. Das Zeichen
      // kommt aus dem CSS — die Klasse `bi` wuerde das Layout des Pads stoeren.
      className: 'baustein-pad-entry',
      title: translate('Als Baustein herauslösen — der Inhalt wird wiederverwendbar'),
      action: {
        click: (_event, el) => herausloesen(el || element, injector),
      },
    },
  };
};
